<div class="container">
  <div class="absolute-center flex-center text-center">
    <h3 style="color:green;" class="xs-mb-15">Successfully Logged Out</h3>
    <div>
      <app-auto-save-dynamic-timer caption="" [showTimer]="true" [displaySecond]="counter"></app-auto-save-dynamic-timer>
    </div>
  </div>
</div>
